import styled from 'styled-components';

const Wrapper = styled.div`
  max-width: 500px;

  .input-container {
    padding-left: 15px;
    padding-right: 15px;
    padding-bottom: 15px;
  }

  .input-grid {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-gap: 15px;
    padding-top: 5px;
  }

  input {
    height: 45px;
    width: 100%;
    background-color: #fff;
    border: ${props => props.retry ? '1px solid #b00009' : '1px solid #d4d4d4'};
    border-radius: 4px;
    padding-left: 37%;
  }

  .retry {
    pointer-events: ${props => props.casoBordeIntentosFallidos ? 'none' : 'unset'};
    cursor: pointer;
    text-decoration: underline;
    font-weight: 600;
    padding-left: 5px;
    color: #b00009;
  }

  .error-message {
    display: flex;
    font-size: 12px;
    color: #b00009;
    margin-top: 3px;
  }

  .success-message {
    display: flex;
    font-size: 12px;
    color: #0e891a;
    margin-top: 5px;
  }

  .retry-message,
  .timer-message {
    display: flex;
    font-size: 13px;
    color: ${props => props.retry ? '#b00009' : '#333333'};
  }

  .timer-message {
    margin-top: 5px;
  }

  .timer {
    padding-right: 3px;
  }

  .img-timer,
  .img-success,
  .img-error {
    padding-right: 5px;
  }
`;

export default Wrapper;
